export default __webpack_public_path__ + "static/ejendomdanmark-2c24d5fcaf715a676949d8e30dad0d66.svg";